import cls from 'classnames';
import IconChevronRightSmall from '@picsart/icons/IconChevronRightSmall';
import IconNewWindow from '@picsart/icons/IconNewWindow';

import { IToolIcon, IToolDataSubcategory } from '../../../../../data/tools/types';
import { SingleToolAppIcon } from '../../../SingleToolAppIcon';

import useStyles from './styles';

type MenuItemProps = {
  textClassName?: string;
  id: string;
  href: string;
  icon: IToolIcon;
  iconRound?: boolean;
  fillColor: string;
  iconColor: string;
  name: string;
  subCategories: IToolDataSubcategory[];
  openInNewTab?: boolean;
  isNew?: boolean;
  setVisible: (id: string) => void;
};

function NavMenuItem({
  id,
  href,
  icon,
  iconRound,
  fillColor,
  iconColor,
  name,
  subCategories,
  openInNewTab,
  isNew,
  setVisible,
  textClassName,
}: MenuItemProps) {
  const classes = useStyles();
  const hasSubCategories = Boolean(subCategories);
  const Element = href ? 'a' : 'div';
  const target = href ? (openInNewTab ? '_blank' : '_self') : undefined;
  const fill = icon.noColor ? 'none' : fillColor || icon.fill;
  const background = icon.noColor ? 'none' : iconColor || icon.background;

  const onMouseEnter = () => {
    if (hasSubCategories) {
      return setVisible(id);
    }

    setVisible('');
  };

  return (
    <Element href={href} target={target} className={classes.root} onMouseEnter={onMouseEnter}>
      <div className={classes.left}>
        {icon && (
          <SingleToolAppIcon
            icon={{
              ...icon,
              fill,
              background,
            }}
            size="small"
            isRound={iconRound}
          />
        )}
        <span className={cls(classes.text, textClassName)}>{name}</span>
      </div>
      <div className={classes.right}>
        {isNew && <div className={classes.newTag}>New</div>}
        {openInNewTab && <IconNewWindow className={classes.newTabIcon} />}
        {hasSubCategories && <IconChevronRightSmall className={classes.arrow} />}
      </div>
    </Element>
  );
}

export default NavMenuItem;
